import { login as loginCall, loginMFA } from 'api/auth';
import { getUser, getUserAvatar } from 'api/users';
import { ROUTES } from 'enum';
import { loginFailed, loginStarted, loginSuccess } from 'store/auth/actions';
import { setUser } from 'store/user/actions';
import * as ACTION_TYPES from 'store/auth/action-types';
import { handlePromises, parseResponseError } from 'utils';
import history from '../../history';

export function login(credentials) {
  return async (dispatch) => {
    try {
      dispatch(loginStarted());
      let result = null;
      if (credentials.code) {
        result = await loginMFA(
          {
            username: credentials.email,
            password: credentials.password,
          },
          credentials.code,
        );
      } else {
        result = await loginCall({
          username: credentials.email,
          password: credentials.password,
        });
      }
      dispatch(loginSuccess({ accessToken: result.accessToken }));
      dispatch({ type: ACTION_TYPES.LOADING_USER_REQUEST });
      const [avatar, user] = await handlePromises([getUserAvatar(credentials.email), getUser(credentials.email)]);
      dispatch(setUser({ ...user, avatar }));
      dispatch({ type: ACTION_TYPES.LOADING_USER_SUCCESS });
      if (localStorage.getItem('commit-reminder') === null) {
        localStorage.setItem('commit-reminder', 'true');
      }
      history.push(ROUTES.CUSTOMERS);
    } catch (error) {
      const errorMessage = parseResponseError(error, {
        400: 'Your email or password is incorrect',
        424: credentials.code ? 'Invalid Code' : 'MFA required',
      });
      dispatch({ type: ACTION_TYPES.LOADING_USER_FAILURE, payload: { message: errorMessage } });
      dispatch(loginFailed({ message: errorMessage }));
    }
  };
}

export const removeAuthError = () => (dispatch) => {
  dispatch(loginFailed({ message: '' }));
};
